module.exports = new __parcel__URL__("hereafterLogo.1a4f95f4.jpg").toString();